import queryString from 'query-string'

import { fetchingAPI, apiService } from '@/api'

import { setLoading, setData } from './recentQuestions.redux'

export const fetchRecentQuestions =
  (feature, limit = 10) =>
  async (dispatch) => {
    dispatch(setLoading({ questions: true }))

    const queryParams = queryString.stringify({ limit })
    try {
      const response = await fetchingAPI(
        `${apiService.summary}/prompts/${feature}/recent?${queryParams}`
      )
      const data = await response
      dispatch(setData({ questions: data }))
    } catch (error) {
      console.error('Error fetching recent questions:', error)
    } finally {
      dispatch(setLoading({ questions: false }))
    }
  }
